/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
import React, { useEffect, useMemo, useState } from 'react';

import { Grid, Container, Typography, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import LoadingButton from '../../components/common/LoadingButton';
import DashboardDetailMobileContainer from '../../components/dashboardDetailMobileContainer/DashboardDetailMobileContainer';
import DashboardNotificationAdditionalFile from '../../components/dashboardNotification/DashboardNotificationAdditionalFile';
import DashboardPlanInfo from '../../components/dashboardPlanInfo/DashboardPlanInfo';
import DashboardStudyDetails from '../../components/dashboardStudyDetails/DashboardStudyDetails';
import DashboardStudyList from '../../components/dashboardStudyList/DashboardStudyList';
import DashboardTour from '../../components/dashboardTour/DashboardTour';
import NoStudies from '../../components/noStudies/NoStudies';
import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => ({
  buttonRequestVideo: {
    marginLeft: '0px',
    marginTop: '12px',
    [theme.breakpoints.up('md')]: {
      marginLeft: '10px',
      marginTop: '24px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '30px',
    },
  },
  buttonUploadNewFile: {
    marginTop: '30px',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '24px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '30px',
    },
  },
  containerButtons: {
    alignItems: 'center',
    display: 'block',
    justifyContent: 'center',
    marginLeft: '0px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      marginLeft: 'auto',
      width: 'fit-content',
    },
  },
  containerList: {
    marginTop: '40px',
    [theme.breakpoints.up('md')]: {
      marginTop: '30px',
    },
  },
  divider: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      height: 1,
      marginBottom: 15,
      marginTop: 15,
    },
  },
  infoContainer: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px !important',
    },
  },
  leftContainer: {
    padding: '40px 0px',
    [theme.breakpoints.up('md')]: {
      padding: '40px 0px 40px 20px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '40px',
    },
  },
  mobileContainer: {
    display: 'block',
    marginBottom: '50px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
      marginBottom: '0px',
    },
  },
  mobileContentRecordContainer: {
    textAlign: 'left',
  },
  planInfo: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: 15,
    },
  },
  responsiveFullWidth: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  },
  rightContainer: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 50px rgba(0, 0, 0, 0.1)',
    display: 'none',
    minHeight: 'calc(95vh - 65px)',
    padding: '40px 20px',
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: '340px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '400px',
    },
  },
  rightContentContainer: {
    maxWidth: '300px',
  },
  rightContentRecordContainer: {
    borderBottom: '1px solid #E0E0E0',
    borderTop: '1px solid #E0E0E0',
    marginTop: '30px',
    padding: '30px 16px 50px 16px',
  },
  rightContentUserContainer: {
    padding: '0px 16px 0px 16px',
  },
  studyDetails: {
    marginTop: '4rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  typographySubtitle: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '0px',
    maxWidth: '408px',
  },
  typographyTitle: {
    color: '#172B4D',
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29px',
    marginBottom: '0px',
  },
}));

export default () => {
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const blocRef = useBlocRef('patientDashboardBloc');

  const [records, setRecords] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [isMediphanyWorkspace, setIsMediphanyWorkspace] = useState(false);
  const [isWhiteGloveWorkspace, setIsWhiteGloveWorkspace] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalAvailableCases, setTotalAvailableCases] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [userDetail, setUserDetail] = useState({});
  const [searchCriteria, setSearchCriteria] = useState({});
  const [runJoyride, setRunJoyride] = useState(false);
  const [availableReport, setAvailableReport] = useState(null);
  const [isMobileDialogDetailOpen, setIsMobileDialogDetailOpen] = useState(false);
  const [updatedAdditionalFile, setUpdatedAdditionalFile] = useState({});
  const [workspaceDetails, setWorkspaceDetails] = useState(null);
  const [shouldRedirectToPackagePlans, setShouldRedirectToPackagePlans] = useState(false);
  const [notPaidCasesTotal, setNotPaidCasesTotal] = useState(null);

  useEffect(() => {
    const recordsSub = blocRef.current.records$.subscribe(setRecords);
    const totalSub = blocRef.current.total$.subscribe(setTotal);
    const selectedSub = blocRef.current.selectedRecord$.subscribe(setSelectedRecord);
    const availableReportSub = blocRef.current.availableReport$.subscribe(setAvailableReport);
    const workspaceSub = blocRef.current.isMediphanyWorkspace$.subscribe(setIsMediphanyWorkspace);
    const userDetailSub = blocRef.current.userDetails$.subscribe(setUserDetail);
    const searchCriteriaSub = blocRef.current.searchCriteria$.subscribe(setSearchCriteria);
    const totalAvailableCasesSub = blocRef.current.totalAvailableCases$.subscribe(setTotalAvailableCases);
    const runJoyrideSub = blocRef.current.runJoyride$.subscribe(setRunJoyride);
    const isMobileDialogDetailOpenSub = blocRef.current.isMobileDialogDetailOpen$.subscribe(setIsMobileDialogDetailOpen);
    const updatedAdditionalFileSub = blocRef.current.updatedAdditionalFile$.subscribe(setUpdatedAdditionalFile);
    const workspaceDetailsSub = blocRef.current.userWorkspace$.subscribe(setWorkspaceDetails);
    const shouldRedirectToPackagePlansSub = blocRef.current.shouldRedirectToPackagePlans$.subscribe(setShouldRedirectToPackagePlans);
    const notPaidCasesTotalSub = blocRef.current.notPaidCasesTotal$.subscribe(setNotPaidCasesTotal);
    const isWhiteGloveWorkspaceSub = blocRef.current.isWhiteGloveWorkspace$.subscribe(setIsWhiteGloveWorkspace);

    try {
      blocRef.current.getCurrentUser();
      blocRef.current.getNotPaidCases();
    } catch (ignore) {}

    return () => {
      recordsSub.unsubscribe();
      totalSub.unsubscribe();
      selectedSub.unsubscribe();
      availableReportSub.unsubscribe();
      workspaceSub.unsubscribe();
      userDetailSub.unsubscribe();
      searchCriteriaSub.unsubscribe();
      totalAvailableCasesSub.unsubscribe();
      runJoyrideSub.unsubscribe();
      isMobileDialogDetailOpenSub.unsubscribe();
      updatedAdditionalFileSub.unsubscribe();
      workspaceDetailsSub.unsubscribe();
      shouldRedirectToPackagePlansSub.unsubscribe();
      notPaidCasesTotalSub.unsubscribe();
      isWhiteGloveWorkspaceSub.unsubscribe();
      blocRef.current.dispose();
    };
  }, []);

  useEffect(() => {
    if (uploadedFiles.length) {
      handleUpload(uploadedFiles);
    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (shouldRedirectToPackagePlans) {
      history.push(`/package-plans?studyId=${selectedRecord.id}`);
    }
  }, [shouldRedirectToPackagePlans]);

  const containerTitle = useMemo(() => {
    if (isWhiteGloveWorkspace) return 'My Personal Medical Record';
    if (isMediphanyWorkspace) return 'Personal Medical Record';
    return 'My Video Reports';
  }, [isMediphanyWorkspace, isWhiteGloveWorkspace]);

  const handleCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);
  };
  const handleStudySelected = (id) => {
    blocRef.current.getSelectedRecord(id);
  };
  const handleRequestVideo = () => {
    if (selectedRecord) {
      return history.push(`/personalized-video?studyId=${selectedRecord?.id}`);
    }

    return history.push(`/personalized-video`);
  };

  const handleDownload = () => blocRef.current.downloadFiles();
  const handleRemove = () => blocRef.current.openRemoveImagesDialog();
  const handleUpgrade = () => history.push('/upgrade-plan?action=upgrade');
  const handleViewImages = () => blocRef.current.viewSelectedImages();

  const handleViewReport = (caseId) => {
    if (caseId) {
      history.push(`/patient-report?recordId=${caseId}`);
    }
  };

  const handleViewSelectedReport = () => {
    if (selectedRecord) {
      history.push(`/patient-report?recordId=${selectedRecord?.id}`);
    }
  };

  const handleShareLink = () => blocRef.current.getShareLink();
  const handleNavigation = (route) => history.push(route);
  const handleRequestVideoReport = () => handleNavigation('/personalized-video');
  const handleOpenMobileDetail = () => blocRef.current.openMobileDialogDetail();
  const handleCloseMobileDetail = () => blocRef.current.closeMobileDialogDetail();
  const handleStopJoyride = () => blocRef.current.closeJoyride();

  const handleOpenSelfhHelpMaterialTour = () => {
    blocRef.current.openSelfHelpMaterialTour();
    history.push('/self-help-materials');
  };

  const handleOpenImagingStudySelector = () => {
    blocRef.current.openSelectImagingStudyDialogSelector();
  };

  const handleUpload = (files) => {
    return blocRef.current.onUpload(files);
  };

  const hanldeBuyVideoReport = () => {
    history.push('/package-plans');
  };

  const handleShareVideoReport = async (id) => {
    await blocRef.current.getShareVideoReport(id);
  };

  const handleFileChange = (evt) => {
    setUploadedFiles([...evt.target.files]);
    evt.target.value = null;
  };

  const handleOpenAdditionalFileDialog = () => {
    blocRef.current.openAdditionalFileDialog();
  };

  const handleViewMoreAdditionalFiles = (files) => {
    blocRef.current.openViewMoreAdditionalFilesDialog(files);
  };

  const handleOpenFileViewer = (file) => {
    blocRef.current.openViewer(file);
  };

  const handleViewUpdatedAdditionalFile = () => {
    blocRef.current.openUpdatedAdditionalFileRecord();
  };

  const handleCloseAdditionalFileRecord = () => {
    blocRef.current.closeUpdatedAdditionalFileRecord();
  };

  const handleMakePayment = () => {
    blocRef.current.makePayment();
  };

  const renderDashboardPlanInfo = (isDesktopView, target = 'desktop') => {
    if (target === 'desktop' && !isDesktopView) return null;
    if (target === 'mobile' && isDesktopView) return null;
    return (
      isMediphanyWorkspace && (
        <DashboardPlanInfo
          userDetail={userDetail}
          isMobileView={!isDesktopView}
          availableReport={availableReport}
          onUpgrade={handleUpgrade}
          onBuyVideoReport={hanldeBuyVideoReport}
        />
      )
    );
  };

  const openMobileDialogDetail = useMemo(() => {
    return !isDesktop && isMobileDialogDetailOpen;
  }, [isDesktop, isMobileDialogDetailOpen]);

  const requestButtonText = useMemo(() => {
    return userDetail?.availableReport || (workspaceDetails?.canRequestBeforePay && !notPaidCasesTotal) ? 'Request Video Report' : 'Buy Video Report';
  }, [userDetail?.availableReport, workspaceDetails?.canRequestBeforePay, notPaidCasesTotal]);

  const workspaceMainFileType = useMemo(() => {
    return workspaceDetails?.mainFileType || 'dicom';
  }, [workspaceDetails?.mainFileType]);

  return (
    <>
      <Grid container style={{ background: '#FFF' }} justify="space-between" wrap="nowrap">
        {/* Left container */}
        <Grid item style={{ flexGrow: '1' }}>
          <Container style={{ width: '100%' }}>
            <div className={classes.leftContainer}>
              <DashboardTour
                onRequestVideo={handleRequestVideoReport}
                runJoyride={runJoyride}
                onCloseJoyride={handleStopJoyride}
                onOpenDialogMobileDetail={handleOpenMobileDetail}
                isMobileView={!isDesktop}
                onCloseDialogMobileDetail={handleCloseMobileDetail}
                onOpenSelfHelpMaterialTour={handleOpenSelfhHelpMaterialTour}
              />

              {/* Dashboard plan info */}
              <div className={classes.mobileContainer}>{renderDashboardPlanInfo(isDesktop, 'mobile')}</div>

              {/* Header */}
              <Grid container justify="space-between" alignItems="flex-end">
                <Grid item xs={12} md={6} lg={7}>
                  <Typography className={`${classes.typographyTitle} text-left`}>{containerTitle}</Typography>
                  <Typography className={`${classes.typographySubtitle} text-left`}>
                    {isMediphanyWorkspace
                      ? 'From here you can do things like access files you have uploaded to the system, request video reports and add new files for storage'
                      : 'From here you can access any video report that was created for you.'}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={5} style={{ textAlign: 'right' }}>
                  {isMediphanyWorkspace && (
                    <div className={classes.containerButtons}>
                      <div>
                        {workspaceMainFileType === 'dicom' ? (
                          <>
                            <input onChange={handleFileChange} multiple directory="" webkitdirectory="" moxdirectory="" hidden id="raised-button-study" type="file" />
                            <label htmlFor="raised-button-study" className={classes.responsiveFullWidth}>
                              <LoadingButton
                                fullWidth
                                variant="outlined"
                                color="primary"
                                component="span"
                                className={`${classes.responsiveFullWidth} ${classes.buttonUploadNewFile} patient-dashboard-uploadnewfile-button`}>
                                Store Files
                              </LoadingButton>
                            </label>
                          </>
                        ) : null}

                        {workspaceMainFileType === 'any' ? (
                          <LoadingButton
                            onClick={handleOpenImagingStudySelector}
                            fullWidth
                            variant="outlined"
                            color="primary"
                            component="span"
                            className={`${classes.responsiveFullWidth} ${classes.buttonUploadNewFile} patient-dashboard-uploadnewfile-button`}>
                            Store Files
                          </LoadingButton>
                        ) : null}
                      </div>

                      <div>
                        <LoadingButton
                          onClick={handleRequestVideoReport}
                          variant="contained"
                          color="primary"
                          className={`${classes.responsiveFullWidth} ${classes.buttonRequestVideo} patient-dashboard-buyvideoreport-button`}>
                          {requestButtonText}
                        </LoadingButton>
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>

              {/* Additional File Notification */}
              <DashboardNotificationAdditionalFile
                updatedAdditionalFile={updatedAdditionalFile}
                onCloseAdiditonalFileRecord={handleCloseAdditionalFileRecord}
                onViewAdditionalFileRecord={handleViewUpdatedAdditionalFile}
              />

              {/* List */}
              <div className={classes.containerList}>
                {totalAvailableCases > 0 ? (
                  <div className="patient-dashboard-studylist">
                    <DashboardStudyList
                      isMediphanyWorkspace={isMediphanyWorkspace}
                      onUpload={handleUpload}
                      total={total}
                      studies={records}
                      onCriteriaChange={handleCriteriaChange}
                      onStudySelected={handleStudySelected}
                      onShareLink={handleShareVideoReport}
                      onViewVideoReport={handleViewReport}
                      isSubmitting$={blocRef.current.isSubmitting$}
                      selectedRecord={selectedRecord}
                      searchCriteria={searchCriteria}
                      workspaceMainFileType={workspaceMainFileType}
                    />
                  </div>
                ) : (
                  <NoStudies
                    onUpload={handleUpload}
                    OnRequestVideo={handleRequestVideo}
                    isSubmitting$={blocRef.current.isSubmitting$}
                    requestButtonText={requestButtonText}
                    workspaceMainFileType={workspaceMainFileType}
                    onOpenImagingStudySelector={handleOpenImagingStudySelector}
                  />
                )}
              </div>
            </div>
          </Container>
        </Grid>

        {/* Right container */}
        <Grid item className={`${classes.rightContainer} patient-dashboard-studydetail`}>
          <div className={`${classes.rightContentContainer}`}>
            <div className={classes.rightContentUserContainer}>{renderDashboardPlanInfo(isDesktop, 'desktop')}</div>

            {/* Selected study */}
            <div className={`${classes.rightContentRecordContainer} patient-dashboard-studydetail-selected-data`}>
              <DashboardStudyDetails
                onViewAdditionalFile={handleOpenFileViewer}
                onRemove={handleRemove}
                onDownload={handleDownload}
                onOpenAdditionalFileDialog={handleOpenAdditionalFileDialog}
                onViewMoreAdditionalFiles={handleViewMoreAdditionalFiles}
                studyStatus={selectedRecord}
                onRequestReport={handleRequestVideo}
                onViewImages={handleViewImages}
                onViewReport={handleViewSelectedReport}
                isLoading$={blocRef.current.isLoadingStudyDetails$}
                onShareImage={handleShareLink}
                onMakePayment={handleMakePayment}
                centerRemoveIcon
              />
            </div>
          </div>
        </Grid>
      </Grid>

      <DashboardDetailMobileContainer onClose={handleCloseMobileDetail} isOpen={openMobileDialogDetail}>
        <div className={`${classes.mobileContentRecordContainer} patient-dashboard-studydetail-selected-data-mobile`}>
          <DashboardStudyDetails
            onViewAdditionalFile={handleOpenFileViewer}
            onRemove={handleRemove}
            onDownload={handleDownload}
            onOpenAdditionalFileDialog={handleOpenAdditionalFileDialog}
            onViewMoreAdditionalFiles={handleViewMoreAdditionalFiles}
            studyStatus={selectedRecord}
            onRequestReport={handleRequestVideo}
            onViewImages={handleViewImages}
            onViewReport={handleViewSelectedReport}
            isLoading$={blocRef.current.isLoadingStudyDetails$}
            onShareImage={handleShareLink}
            onMakePayment={handleMakePayment}
          />
        </div>
      </DashboardDetailMobileContainer>
    </>
  );
};
